import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '视频专区', href: '#media' },
  { label: '热度榜单', href: '#ranking' },
  { label: '热门吃瓜', href: '#cards' },
  { label: '平台特色', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 mx-auto flex items-center justify-between h-[60px] md:h-[68px]">
        <a
          href="#hero"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 md:w-9 md:h-9 bg-primary-500 rounded-lg flex items-center justify-center">
            <span className="text-background-50 font-bold text-sm md:text-base font-heading">17</span>
          </span>
          <span
            className={`font-heading font-bold text-lg md:text-xl transition-colors ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            17吃瓜网
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-3 pt-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}